// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_APP_VERSION = "v1";
export const VERSION_DATE = "June 17. 2026";
export const VERSION_TAG = "V.2.0.8";
